import React, { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const PhotoGallery = ({ images = [], title = "" }) => {
  const [idx, setIdx] = useState(null);
  if (!images.length) return null;
  const go = (d) => setIdx((i) => (i + d + images.length) % images.length);
  return (
    <section className="mt-12" data-testid="photo-gallery">
      <h3 className="font-display text-2xl mb-5">Photos</h3>
      <div className="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory [-webkit-overflow-scrolling:touch]">
        {images.map((src, i) => (
          <button key={src + i} onClick={() => setIdx(i)} data-testid={`gallery-thumb-${i}`}
            className="snap-start flex-shrink-0 w-[70vw] sm:w-72 aspect-[4/3] rounded-2xl overflow-hidden border border-[color:var(--line)] card-lift">
            <img src={src} alt={`${title} photo ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
      {idx !== null && (
        <div className="fixed inset-0 z-[100] bg-black/90 grid place-items-center p-4" onClick={() => setIdx(null)} data-testid="gallery-lightbox">
          <img src={images[idx]} alt="" className="max-h-[85vh] max-w-full rounded-2xl object-contain" onClick={(e) => e.stopPropagation()} />
          <button className="absolute top-5 right-5 p-2 rounded-full bg-white/10 text-white" onClick={() => setIdx(null)} data-testid="gallery-close"><X size={20} /></button>
          {images.length > 1 && (
            <>
              <button className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/10 text-white" onClick={(e) => { e.stopPropagation(); go(-1); }}><ChevronLeft size={22} /></button>
              <button className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/10 text-white" onClick={(e) => { e.stopPropagation(); go(1); }}><ChevronRight size={22} /></button>
            </>
          )}
        </div>
      )}
    </section>
  );
};
